module.exports = __webpack_public_path__ + "img/feature-12-2.a083e26b.png";